import { render, staticRenderFns } from "./references.vue?vue&type=template&id=6573cdbf&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./references.vue?vue&type=script&lang=js&"
export * from "./references.vue?vue&type=script&lang=js&"
import style0 from "./references.scss?vue&type=style&index=0&id=6573cdbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573cdbf",
  null
  
)

export default component.exports